// @Version: 1.0.0
import { Component, Input } from '@angular/core';

@Component({
   selector: 'app-right-logo',
   templateUrl: './right-logo.component.html',
   standalone: false
})
export class RightLogoComponent {

   @Input() showActionLogo: boolean = false; 
}
